import React from 'react';
import { compose } from 'redux';
import { useTheme } from '@mui/material/styles';

import {
  Box,
  Typography,
} from '@mui/material';

import {
  AccessTime as RecentIcon,
} from '@mui/icons-material';

import PaperSection from '../Components/PaperSection';
import VirtualisedTable, { FONT_SIZE_L } from '../Components/VirtualisedTable/VirtualisedTable';

import { useWindowDimensions } from '../../Utils/ScreenSize';
import { getColumns } from './columns';
import { renderRow } from './rows';

import withUserData from '../../redux/WithData/user';
import withTrackerData from '../../redux/WithData/tracker';
import withTrackerActions from '../../redux/WithActions/tracker';

const RecentUnitsSection = ({
  hasStartedLoading,
  sx,

  role,
  recentTrackers,
  areRecentTrackersLoading,
}) => {
  const theme = useTheme();
  const windowDimensions = useWindowDimensions();

  const columns = getColumns(windowDimensions, theme, role);

  return (
    <PaperSection sx={{ ...sx, p: 0 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2, mb: 2, mr: 3, ml: 3 }}>
        <RecentIcon fontSize="large" sx={{ m: 'auto 0' }}/>
        <Typography variant="h4" sx={{ ml: 1 }}>Recently-viewed Units</Typography>
      </Box>

      <Box sx={{ height: '100%', position: 'relative' }}>
        <VirtualisedTable
          hover
          rowHeight={48}
          fontSize={FONT_SIZE_L}
          columns={columns}
          rowRenderer={renderRow}
          loading={!hasStartedLoading || areRecentTrackersLoading}
          rowCount={!hasStartedLoading || areRecentTrackersLoading ? 0 : recentTrackers.length}
          rowGetter={({ index }) => recentTrackers[index]}
        />
      </Box>
    </PaperSection>
  )
}

export default compose(withUserData, withTrackerData, withTrackerActions)(RecentUnitsSection);